import { render, staticRenderFns } from "./CibilAllDetailsDialog.vue?vue&type=template&id=abdbc2ec&scoped=true"
import script from "./CibilAllDetailsDialog.vue?vue&type=script&lang=js"
export * from "./CibilAllDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./CibilAllDetailsDialog.vue?vue&type=style&index=0&id=abdbc2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdbc2ec",
  null
  
)

export default component.exports